<div layout-vertical>
  <div (click)="toggleOpenClose.emit()">
    <ng-template [ngTemplateOutlet]="triggerTemplate" />
  </div>
  <div [@openClose]="!(!open && canClose)" class="collapse-wrap">
    <ng-content />
  </div>
</div>
